import PageContentLoader from './PageContentLoader'
import PageFeaturedImageLoader from './PageFeaturedImageLoader'
import PageTitleLoader from './PageTitleLoader'

function PageLoader() {
  return (
    <div className="my-10 space-y-10">
      <PageTitleLoader />
      <PageFeaturedImageLoader />
      <PageContentLoader />
    </div>
  )
}

export default PageLoader
